import { render, staticRenderFns } from "./HolidayStatsGrid.vue?vue&type=template&id=2dad2e0e&scoped=true"
import script from "./HolidayStatsGrid.vue?vue&type=script&lang=js"
export * from "./HolidayStatsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad2e0e",
  null
  
)

export default component.exports